import { useConnectedWallet, useWallet } from '@terra-money/wallet-provider'
import { contractAddresses } from 'constants/address'
import { AssetData } from 'constants/assets'
import { TaskNameId } from 'constants/constants'
import { defaultNetworkName, NetworkName } from 'constants/network'
import { Token2BNumber } from 'interfaces/index.interface'
import { useEffect, useRef } from 'react'
import { assetService } from 'services/assetService'
import { oraclePriceService } from 'services/oracleService'
import { oracleStore, taskStore } from 'stores'

interface Props {
  oracleAddr?: string
  assetDatas?: AssetData[]
  poolAddr: string
}

export const useOraclePrice = ({
  oracleAddr,
  assetDatas = assetService.assetArray(),
  poolAddr,
}: Props) => {
  const { network } = useWallet()
  const connectedWallet = useConnectedWallet()

  const contractAddress =
    contractAddresses[
      connectedWallet ? (network.name as NetworkName) : defaultNetworkName
    ]

  if (!oracleAddr) {
    oracleAddr = contractAddress.oracle
  }

  const { getPrice } = oraclePriceService
  const assetsRef = useRef(assetDatas)

  useEffect(() => {
    const fetchPrice = async () => {
      if (!oracleAddr) return
      let newOraclePrices: Token2BNumber = {}

      await Promise.all(
        assetsRef.current.map(async (assetData: AssetData) => {
          try {
            const oraclePrice = await getPrice(
              oracleAddr as string,
              assetData.terraAddress,
            )
            newOraclePrices[assetData.terraAddress] = oraclePrice
          } catch (e) {
            console.error(e)
          }
        }),
      )

      oracleStore.setPoolPriceOracle(poolAddr, newOraclePrices)
    }

    taskStore.updateTask(fetchPrice, TaskNameId.oraclePrice)
    fetchPrice()
  }, [getPrice, oracleAddr, poolAddr])
}
